export enum EnumReviewStatus {
    Pending = 'PENDING',
    Delayed = 'DELAYED',
    Ignored = 'IGNORED',
    Completed = 'COMPLETED'
}